<template>
  <!-- 智能硬件系统 -->
  <div class="hardware">
    <div class="box">
      <div class="header">
        <div class="title">智能硬件系统</div>
        <div class="border"></div>
      </div>
      <div class="body">
        <div class="left">
          <div class="list">
            <router-link
              class="item"
              v-for="item in hardwareLeftList"
              :key="item.id"
              :style="
                hardwareLeftId == item.id
                  ? `background-image: url(${item.open});`
                  : ``
              "
              @mouseenter="hardwareLeftMove(item.id)"
              @mouseleave="hardwareLeftOut"
              :to="item.path"
            >
              <img class="logo" :src="item.logo" alt="" />
              <div class="title">{{ item.title }}</div>
              <div class="more" v-if="hardwareLeftId == item.id">
                <div>了解更多</div>
                <img :src="more" alt="" />
              </div>
              <div v-else>
                <div class="text" v-for="i in item.children" :key="i.id">
                  {{ i.title }}
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="center">
          <div class="title">打破硬件信息孤岛 实现场景化联动</div>
          <div class="text">
            通过对智能硬件的深度整合、统一管控，运用先进的互联网云技术、物联网技术，打造信息化、数字化、智能化、平台化的云数据管理平台，帮助物业建立安全、高效、智能、便利的智慧化新社区
          </div>
          <div class="flex">
            <img :src="yesLogo" alt="" />
            <div>一体化服务</div>
          </div>
          <div class="flex">
            <img :src="yesLogo" alt="" />
            <div>场景化联动</div>
          </div>
          <div class="flex">
            <img :src="yesLogo" alt="" />
            <div>智能云服务</div>
          </div>
        </div>

        <div class="right">
          <div class="list">
            <router-link
              class="item"
              v-for="item in hardwareRightList"
              :key="item.id"
              :style="
                hardwareRightId == item.id
                  ? `background-image: url(${item.open});`
                  : ``
              "
              @mouseenter="hardwareRightMove(item.id)"
              @mouseleave="hardwareRightOut"
              :to="item.path"
            >
              <img class="logo" :src="item.logo" alt="" />
              <div class="title">{{ item.title }}</div>
              <div class="more" v-if="hardwareRightId == item.id">
                <div>了解更多</div>
                <img :src="more" alt="" />
              </div>
              <div v-else>
                <div class="text" v-for="i in item.children" :key="i.id">
                  {{ i.title }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import hardware1 from "../../../assets/home/hardware1.png";
import hardware2 from "../../../assets/home/hardware2.png";
import hardware3 from "../../../assets/home/hardware3.png";
import hardware4 from "../../../assets/home/hardware4.png";
import hardware5 from "../../../assets/home/hardware5.png";
import hardware6 from "../../../assets/home/hardware6.png";
import hardware7 from "../../../assets/home/hardware7.png";
import hardware8 from "../../../assets/home/hardware8.png";

import hardwareClose from "../../../assets/home/hardwareClose.png";

import hardwareOpen1 from "../../../assets/home/hardwareOpen1.png";
import hardwareOpen2 from "../../../assets/home/hardwareOpen2.png";
import hardwareOpen3 from "../../../assets/home/hardwareOpen3.png";
import hardwareOpen4 from "../../../assets/home/hardwareOpen4.png";
import hardwareOpen5 from "../../../assets/home/hardwareOpen5.png";
import hardwareOpen6 from "../../../assets/home/hardwareOpen6.png";
import hardwareOpen7 from "../../../assets/home/hardwareOpen7.png";
import hardwareOpen8 from "../../../assets/home/hardwareOpen8.png";

import yesLogo from "../../../assets/home/yesLogo.png";

import more from "../../../assets/home/more.png";

export default {
  setup() {
    return reactive({
      more: more,
      hardwareClose: hardwareClose,
      hardwareLeftList: [
        {
          id: 1,
          title: "智能门禁",
          open: hardwareOpen1,
          logo: hardware1,
          path: "/pc/programme/accesscontrol",
          children: [
            {
              id: 1,
              title: "一键开门",
            },
            {
              id: 2,
              title: "人脸识别",
            },
            {
              id: 3,
              title: "访客邀约",
            },
          ],
        },
        {
          id: 2,
          title: "智能监控",
          open: hardwareOpen2,
          logo: hardware2,
          path: "/pc/programme/monitor",
          children: [
            {
              id: 1,
              title: "远程监控",
            },
            {
              id: 2,
              title: "防御报警",
            },
            {
              id: 3,
              title: "视频回放",
            },
          ],
        },
        {
          id: 3,
          title: "智能充电",
          open: hardwareOpen3,
          logo: hardware3,
          path: "/pc/programme/charge",
          children: [
            {
              id: 1,
              title: "智能充电",
            },
            {
              id: 2,
              title: "在线充值",
            },
            {
              id: 3,
              title: "实时计费",
            },
          ],
        },
        {
          id: 4,
          title: "智能家居",
          open: hardwareOpen4,
          logo: hardware4,
          path: "/pc/programme/homefurnishing",
          children: [
            {
              id: 1,
              title: "智能操控",
            },
            {
              id: 2,
              title: "一键启动",
            },
            {
              id: 3,
              title: "安全省心",
            },
          ],
        },
      ],
      hardwareRightList: [
        {
          id: 1,
          title: "智能能耗",
          open: hardwareOpen5,
          logo: hardware5,
          path: "/pc/programme/energyconsumption",
          children: [
            {
              id: 1,
              title: "远程抄表",
            },
            {
              id: 2,
              title: "在线缴费",
            },
            {
              id: 3,
              title: "负荷预警",
            },
          ],
        },
        {
          id: 2,
          title: "智能梯控",
          open: hardwareOpen6,
          logo: hardware6,
          path: "/pc/programme/laddercontrol",
          children: [
            {
              id: 1,
              title: "限次管理",
            },
            {
              id: 2,
              title: "智能识别",
            },
            {
              id: 3,
              title: "分区域管理",
            },
          ],
        },
        {
          id: 3,
          title: "智能停车",
          open: hardwareOpen7,
          logo: hardware7,
          path: "/pc/programme/parking",
          children: [
            {
              id: 1,
              title: "高峰畅行",
            },
            {
              id: 2,
              title: "一键挪车",
            },
            {
              id: 3,
              title: "智能识别车牌",
            },
          ],
        },
        {
          id: 4,
          title: "楼宇对讲",
          open: hardwareOpen8,
          logo: hardware8,
          path: "/pc/programme/intercom",
          children: [
            {
              id: 1,
              title: "安全智能",
            },
            {
              id: 2,
              title: "音质清晰",
            },
            {
              id: 3,
              title: "一键开启可视对讲",
            },
          ],
        },
      ],
      yesLogo: yesLogo,
      hardwareLeftId: 0,
      hardwareRightId: 0,
    });
  },
  methods: {
    hardwareLeftMove(id) {
      this.hardwareLeftId = id;
    },
    hardwareLeftOut() {
      this.hardwareLeftId = 0;
    },
    hardwareRightMove(id) {
      this.hardwareRightId = id;
    },
    hardwareRightOut() {
      this.hardwareRightId = 0;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 1180px) {
  .hardware {
    min-width: 1180px;
  }
}
.hardware {
  background: linear-gradient(315deg, #122437 0%, #213d5b 100%);
  padding: 60px 0;
  margin-top: 60px;
}
.box {
  width: 1180px;
  margin: 0 auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
  color: #fff;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  display: flex;
  justify-content: space-between;
  margin-top: 64px;
}
.body .left .list,
.body .right .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
.body .left .list .item,
.body .right .list .item {
  width: 190px;
  height: 180px;
  text-align: center;
  background: linear-gradient(225deg, #203c59 0%, #111f2e 100%);
  box-shadow: 20px 20px 20px 1px rgba(16, 18, 23, 0.2);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-decoration: none;
  margin-bottom: 57px;
  position: relative;
  background-position: center;
}
.body .left .list .item:hover,
.body .right .list .item:hover {
  animation: itemHover 2s;
}
@keyframes itemHover {
  0% {
    background-size: 100% 100%;
  }
  100% {
    background-size: 120% 120%;
  }
}
.body .left .list .item .logo,
.body .right .list .item .logo {
  width: 48px;
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
}
.body .left .list .item .title,
.body .right .list .item .title {
  font-size: 16px;
  color: #fff;
  margin-top: 40px;
}
.body .left .list .item .text,
.body .right .list .item .text {
  font-size: 13px;
  color: #d1e8ff;
  margin-top: 15px;
}
.body .left .list .item .more,
.body .right .list .item .more {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #fff;
  margin-top: 80px;
}
.body .left .list .item .more img,
.body .right .list .item .more img {
  width: 14px;
  margin-left: 8px;
}

.body .center {
  width: 340px;
  height: 418px;
  padding: 30px;
  background-image: url(../../../assets/home/centerBack.png);
  background-size: 340px 418px;
  background-repeat: no-repeat;
}
.body .center .title {
  text-align: center;
  font-size: 18px;
  color: #f0f0f0;
}
.body .center .text {
  width: 280px;
  margin: 15px auto 0;
  font-size: 14px;
  color: #d1e8ff;
}
.body .center .flex {
  width: 280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.body .center .flex img {
  width: 18px;
  margin-right: 20px;
}
.body .center .flex div {
  font-size: 14px;
  color: #d1e8ff;
}
</style>
